import { Input } from '@angular/core';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { DevicePilomat } from '../model/devicePilomat';
import { DeviceService } from '../service/device.service';
import { Log } from '../util/log';
import { FormControl } from "@angular/forms";
import { DateHelper } from '../util/dateHelper';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { AccessLogEvent } from '../model/accessLogEvent';
import { RemoteHelper } from '../util/remoteHelper';
import { AccessMethod } from '../model/accessMethod';
import { PageEvent } from '@angular/material/paginator';
import { DateAdapter } from '@angular/material/core';
import { AppComponent } from '../app.component';
import { StringHelper } from '../util/stringHelper';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from "@angular/material/dialog";
import { Overlay } from "@angular/cdk/overlay";
import { LoaderDialogComponent } from '../loader-dialog/loader-dialog.component';


@Component({
  selector: 'app-access-log',
  templateUrl: './access-log.component.html',
  styleUrls: ['./access-log.component.css']
})
export class AccessLogComponent implements OnInit {

  @Input() device: DevicePilomat;
  @ViewChild('logloader', { static: true }) loader;
  @ViewChild('accesslogtable', { static: true }) table;
  @ViewChild(MatSort) sort: MatSort;

  fromFormControl: FormControl;
  toFormControl: FormControl;
  logDateTo: Date = new Date();
  logDateFrom: Date = new Date();
  showDatePickers: Boolean = false;
  displayedColumns: string[] = [
    'date',
    'subscription',
    'user',
    // 'activationCode',
    'state',
    'method'
  ];
  filterString: string = "";

  logList: AccessLogEvent[];
  dataSource: MatTableDataSource<AccessLogEvent>;

  pageEvent: PageEvent;
  pageSize: number = 200;
  maxPages: number = 0;
  pageLength: number = 0;
  tableItemsTotalCounter: number = 0;
  pageSizeOptions: number[] = [200];
  currentPage: number = 0;

  accessMethodTypes: Array<any> = [];

  remoteType = AccessMethod.EVENT_TYPE_REMOTE;
  remote1cType = AccessMethod.EVENT_TYPE_REMOTE1CONTROL;
  appType = AccessMethod.EVENT_TYPE_APP;
  carType = AccessMethod.EVENT_TYPE_CAR;
  phoneType = AccessMethod.EVENT_TYPE_PHONE;
  webType = AccessMethod.EVENT_TYPE_WEB;
  apiType = AccessMethod.EVENT_TYPE_API;
  badgeType = AccessMethod.EVENT_TYPE_BADGE;
  pinCodeType = AccessMethod.EVENT_TYPE_PINCODE;

  pickedTimeRangeValue: string = "1";

  csvData: string = "";


  constructor(
    public appComponent: AppComponent,
    private deviceService: DeviceService,
    public dialog: MatDialog,
    private overlay: Overlay,
    private cdRef: ChangeDetectorRef,
    private dateAdapter: DateAdapter<any>
  ) {
    this.dateAdapter.setLocale($localize`:@@accesslog_datepicker_locale:it`);

    this.accessMethodTypes = [
      { value: this.appType, text: $localize`:@@accessMethod_app:App` },
      { value: this.carType, text: $localize`:@@accessMethod_car:Targa` },
      { value: this.remote1cType, text: $localize`:@@accessMethod_remote1C:Radiocomando 1Control` },
      { value: this.remoteType, text: $localize`:@@accessMethod_remoteJCM:Radiocomando` },
      { value: this.phoneType, text: $localize`:@@accessMethod_phone:Telefono` },
      { value: this.webType, text: $localize`:@@accessMethod_web:Web` },
      { value: this.apiType, text: $localize`:@@accessMethod_api:Api` },
      { value: this.badgeType, text: $localize`:@@accessMethod_badge:Badge` },
      { value: this.pinCodeType, text: $localize`:@@accessMethod_pincode:Codice PIN` }
    ]
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.loader.showLoading();
    this.logDateTo = new Date();
    this.logDateFrom = new Date();

    this.logDateTo.setHours(23, 59);
    this.logDateFrom.setHours(0, 0);

    this.toFormControl = new FormControl(this.logDateTo);
    this.fromFormControl = new FormControl(this.logDateFrom);

    setTimeout(() => {

      // this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo));
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    });
  }

  setLogTimeRange(picked: any) {
    this.loader.showLoading();
    this.pickedTimeRangeValue = picked.value;

    if (picked.value == "1") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();
      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);
      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    } else if (picked.value == "2") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setDate(this.logDateTo.getDate() - 1);
      this.logDateFrom.setDate(this.logDateFrom.getDate() - 1);

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);
      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    } else if (picked.value == "3") {
      this.showDatePickers = true;
      this.loader.hideLoading();
    }
  }

  refreshData() {
    this.loader.showLoading();

    if (this.pickedTimeRangeValue == "1") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);

      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    } else if (this.pickedTimeRangeValue == "2") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setDate(this.logDateTo.getDate() - 1);
      this.logDateFrom.setDate(this.logDateFrom.getDate() - 1);

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);

      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    } else if (this.pickedTimeRangeValue == "3") {
      this.confirmDateSelection();
    }
  }

  convertJcmCode(code: string) {
    return RemoteHelper.standardCodeToJcmCode(code);
  }

  confirmDateSelection() {
    if (this.fromFormControl.value) {
      this.logDateFrom = new Date(this.fromFormControl.value);
    }
    if (this.toFormControl.value) {
      this.logDateTo = new Date(this.toFormControl.value);
    }

    this.logDateTo.setHours(23, 59)
    this.logDateFrom.setHours(0, 0)

    this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

  }

  onKey(event: any) {

    this.filterString = event.target.value;

    this.table.dataSource.filter = this.filterString.trim().toLowerCase();
  }

  filterTable(data: AccessLogEvent, filter: string): boolean {

    if (data.tableWay && data.tableWay.toLowerCase().indexOf(filter) != -1) {
      return true;
    } else if (data.userOwnerName && data.userOwnerName.toLowerCase().indexOf(filter) != -1) {
      return true;
    } else if (data.name && data.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    } else if (data.userUid && data.userUid.toLowerCase().indexOf(filter) != -1) {
      return true;
    } else if (data.activationCode && data.activationCode.toLowerCase().indexOf(filter) != -1) {
      return true;
    } else if (data.code && data.code.toLowerCase().indexOf(filter) != -1) {
      return true;
    } else if (data.tableState && data.tableState.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    return false;
  }

  isService(): boolean {
    return this.appComponent.isService();
  }

  loadData(dateFrom: string, dateTo: string, page: number) {


    Log.debug("\n\n\t\tAccess log loadData:");
    Log.debug("\tdateFrom");
    Log.debug(dateFrom);


    Log.debug("\tdateTo");
    Log.debug(dateTo);

    this.loader.showLoading();

    this.currentPage = page;

    this.deviceService.getAccessesCount(this.device.serial, dateFrom, dateTo).subscribe(data => {

      this.tableItemsTotalCounter = data.count;
      this.maxPages = Math.ceil(data.count / this.pageSize);

      const obs = this.deviceService.getAccessLogWithDate(this.device.serial, dateFrom, dateTo, page);
      obs.subscribe(data => {

        for (let i = 0; i < data.length; i++) {
          data[i].tableState = this.getState(data[i].state);
          data[i].tableWay = this.getAccessMethodType(data[i]);
          //se l'utente é loggato allora name corrisponde alla mail, mostrare mail se disponibile e non code parsato
          if (data[i].way == AccessMethod.EVENT_TYPE_REMOTE && data[i].code == data[i].name) {
            data[i].code = this.convertJcmCode(data[i].code).toString();
          } else if (data[i].way == AccessMethod.EVENT_TYPE_PHONE || data[i].way == AccessMethod.EVENT_TYPE_CAR || data[i].way == AccessMethod.EVENT_TYPE_API) {
            //do nothing, così l'else raggruppa tutti gli altri casi
          } else {
            data[i].code = data[i].name;
          }

          if (this.isService()) {
            data[i].code = StringHelper.censorString(data[i].code);

            data[i].name = StringHelper.censorString(data[i].name);

            if (data[i].userOwnerName) {
              data[i].userOwnerName = StringHelper.censorString(data[i].userOwnerName);
            }

          }
        }


        this.logList = data;
        this.table.dataSource = new MatTableDataSource(this.logList);
        this.table.dataSource.filterPredicate = this.filterTable;
        this.table.dataSource.sort = this.sort;
        this.table.dataSource.filter = this.filterString.trim().toLowerCase();
        setTimeout(() => {
          this.loader.hideLoading();
        }, 150);
        this.cdRef.detectChanges();
      });
    });
  }


  getState(state: string) {
    if (state == "Granted") {
      return $localize`:@@access_log_access_granted:Accesso consentito`;
    } else if (state == "Denied") {
      return $localize`:@@access_log_access_denied:Accesso negato`;
    } else if (state == "DeniedInvalidInstallation") {
      return $localize`:@@access_log_access_denied_invalid_installation:Accesso negato: errore login app`; //da rivedere
    } else if (state == "DeniedNotEnabledToday") {
      return $localize`:@@access_log_access_denied_invalid_day:Accesso negato: giorno non permesso`;
    } else if (state == "DeviceOffline") {
      return $localize`:@@access_log_access_denied_device_offline:Accesso negato: dispositivo offline`;
    } else if (state == "DeniedTooFar") {
      return $localize`:@@access_log_access_denied_too_far:Accesso negato: utente troppo distante`;
    } else if (state == "InternalError") {
      return $localize`:@@access_log_access_denied_device_internal_error:Accesso negato: errore interno`;
    }
  }


  getAccessMethodType(method: AccessLogEvent) {
    for (let i = 0; i < this.accessMethodTypes.length; i++) {
      if (method.way == this.accessMethodTypes[i].value) {
        if (method.readerCount >= 0) {
          return this.accessMethodTypes[i].text + "(" + method.readerCount + ")";
        }

        return this.accessMethodTypes[i].text;
      }
    }
  }

  isSelectIconType(element) {
    if (element.way == this.phoneType || element.way == this.carType || element.way == this.webType || element.way == this.appType || element.way == this.apiType || element.way == this.pinCodeType || element.way == this.badgeType) {
      return true;
    }
    else {
      return false;
    }
  }

  selectIcon(type: string): string {
    if (type == this.remoteType) {
      return "jcm";
    } else if (type == this.remote1cType) {
      return "why";
    } else if (type == this.webType || type == this.apiType) {
      return "cloud";
    } else if (type == this.appType) {
      return "mobile-alt";
    } else if (type == this.phoneType) {
      return "phone-alt";
    } else if (type == this.pinCodeType) {
      return "calculator";
    } else if (type == this.badgeType) {
      return "id-badge";
    }
    return "car"
  }

  isNumber(name: string): boolean {
    if (Number(name)) {
      return true;
    } else {
      return false;
    }
  }


  changePage(event?: PageEvent) {

    Log.debug("changePage - pageIndex:  " + event.pageIndex);

    this.currentPage = event.pageIndex;
    this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), this.currentPage);
  }


  downloadCsv() {

    let message = $localize`:@@accesslog_log_download_confirm:Procedere con il download? Si prega di non aggiornare la pagina durante la procedura`;
    let header = $localize`:@@accesslog_log_download_confirm_header:Richiesta conferma`;
    let confirmMessage = $localize`:@@accesslog_log_download_confirm_yes:Conferma`;
    let cancelMessage = $localize`:@@accesslog_log_download_confirm_no:Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, header, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {

        let header = $localize`:@@accesslog_log_download_in_progress:Download in corso`;

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const loaderDialogRef = this.dialog.open(LoaderDialogComponent, {
          width: "350px",
          data: { header, loading: true },
          scrollStrategy,
        });

        this.deviceService.downloadLogCsv(this.device.serial, DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo)).subscribe(logUrl => {

          if (logUrl == "") {
            setTimeout(() => {
              loaderDialogRef.close(); // close loader on error
              this.openErrorDialog();
            }, 2000);

          } else {

            this.csvData = logUrl;
            let filename = $localize`:@@accesslog_log_export:Export registro accessi`;
            let dwldLink = document.createElement("a");
            let url = logUrl;
            let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
            if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
              dwldLink.setAttribute("target", "_blank");
            }
            dwldLink.setAttribute("href", url);
            dwldLink.setAttribute("download", filename + ".csv");
            dwldLink.style.visibility = "hidden";
            document.body.appendChild(dwldLink);
            dwldLink.click();
            document.body.removeChild(dwldLink);

            loaderDialogRef.close();

          }

        }, error => {
          loaderDialogRef.close(); // close loader on error

          setTimeout(() => {
            this.openErrorDialog();
          }, 2000);
        });

      }
    });

  }


  openErrorDialog() {
    let header = $localize`:@@userslist_permissions_export_in_progress:Download in corso`;
    let message = $localize`:@@userslist_permissions_export_error:Si é verificato un errore durante il download, si prega riprovare più tardi`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { header, message },
      scrollStrategy,
    });
  }
}



export class LogSource extends MatTableDataSource<AccessLogEvent> {

  isLoading = new BehaviorSubject(false);
  logData = new BehaviorSubject<AccessLogEvent[]>([]);

  constructor(private serial: string, private deviceService: DeviceService, private dateFrom: Date, private dateTo: Date) {
    super();
  }

  loadData() {

    this.isLoading.next(true);

    const obs = this.deviceService.getAccessLogWithDate(this.serial, DateHelper.formatDateForApi(this.dateFrom), DateHelper.formatDateForApi(this.dateTo), 0);
    // const obs = this.deviceService.getLog(this.serial);
    obs.subscribe(data => {

      this.isLoading.next(false);
      this.logData.next(data);
    });
  }

  connect(): BehaviorSubject<AccessLogEvent[]> {

    this.loadData();
    return this.logData;
  }

  disconnect() {
  }
}
